import { render, staticRenderFns } from "./StepTab4.vue?vue&type=template&id=00dcd149&scoped=true"
import script from "./StepTab4.vue?vue&type=script&lang=js"
export * from "./StepTab4.vue?vue&type=script&lang=js"
import style0 from "./StepTab4.vue?vue&type=style&index=0&id=00dcd149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dcd149",
  null
  
)

export default component.exports